function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 36H7.8C3.5 36 .1 32.5.1 28.3V7.8C.1 3.5 3.6.1 7.8.1h20.5C32.6.1 36 3.6 36 7.8v20.5c0 4.2-3.5 7.7-7.7 7.7z",
  fill: "#36a6de"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.4 17.5l12.1-5c1.2-.5 5.2-2.2 5.2-2.2s1.9-.7 1.7 1c-.1.7-.5 3.3-.9 6l-1.3 8.2s-.1 1.2-1 1.4c-.9.2-2.3-.7-2.6-.9-.2-.2-3.9-2.5-5.2-3.6-.4-.3-.8-.9.1-1.7 1.9-1.7 4.1-3.8 5.5-5.2.6-.6 1.2-2.1-1.3-.3l-7.3 4.9s-.8.5-2.4.1-3.4-1.1-3.4-1.1-1.4-.8.8-1.6z",
  fill: "#fff"
})));